module.exports = __webpack_public_path__ + "img/laswerk1.798ec606.jpeg";